import {Inject, Injectable} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import {getProfile, UserState} from 'src/app/login/state/user.reducers';
import { first, flatMap } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private store$: Store<UserState>, @Inject(DOCUMENT) private document: Document) {}


  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return this.store$.select(getProfile).pipe(
      first(),
      flatMap((profile: UserState) => {
        const authReq = !!profile.sessionToken
          ? request.clone({
              setHeaders: {
                Authorization: `Bearer ${profile.token}`,
                'x-session-token': profile.sessionToken || '',
              },
            })
          : request;
        return next.handle(authReq);
      })
    );
  }
}
